import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Project } from 'src/app/model/project/project';
import { SubProject } from 'src/app/model/project/sub-project';
import { STATUS } from '../../../../../model/project/status';

@Component({
  selector: 'app-placement-step-content',
  templateUrl: './placement-step.component.html',
  styleUrls: ['./placement-step.component.scss'],
})
export class PlacementStepComponent implements OnInit {
  @Input()
  project: Project;

  @Input()
  subProject: SubProject;

  @Input()
  client: boolean = false;

  @Output()
  save = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
    if (
      this.subProject.status === STATUS.DRAFT.valueOf() &&
      this.subProject.projectPlacement != null
    ) {
      this.subProject.withPlacement = true;
    }
  }

  setWithPlacement(value: boolean) {
    this.subProject.withPlacement = value;
    this.save.emit();
  }

  setPickupInfo(event) {
    this.subProject.pickup.extraInfoPickup = event;
    this.save.emit();
  }

  protected readonly STATUS = STATUS;
}
